import React from 'react';

import ChangeBadge from '../change-badge';

import type { ChangeValue } from '../../results-step.types';

interface NewAdmitsBadgeProps {
  newAdmits: ChangeValue | null;
}

const NewAdmitsBadge = ({
  newAdmits,
}: NewAdmitsBadgeProps): React.JSX.Element | null => {
  if (!newAdmits) return null;

  return (
    <div className="flex items-center gap-1" data-testid="admit-new-admits">
      <span className="text-sm text-gray-700">New admits:</span>
      <ChangeBadge
        change={newAdmits}
        variant="total"
        data-testid="admit-new-admits-value"
      />
    </div>
  );
};

export default NewAdmitsBadge;
